import React from "react";
import { StyledButton, StyledButtonText } from "./styled";
import { ButtonProps, Type } from "./types";

const ButtonBase = ({
  className,
  onClick,
  text,
  buttonType = Type.PRIMARY,
  children,
  disabled,
}: ButtonProps) => (
  <StyledButton
    className={className}
    onClick={onClick}
    buttonType={buttonType}
    disabled={disabled}
  >
    {children}
    <StyledButtonText>{text}</StyledButtonText>
  </StyledButton>
);

export default ButtonBase;
